/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_Info_Dialog_DescInputs */

const vi_print_info_dialog_desc = /** @type {(inputs: Print_Info_Dialog_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông tin sửa ở đây chỉ áp dụng cho lần in này, không thay đổi đơn hàng.`)
};

/**

* @param {Print_Info_Dialog_DescInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const print_info_dialog_desc = /** @type {((inputs?: Print_Info_Dialog_DescInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_Info_Dialog_DescInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_print_info_dialog_desc(inputs)
});